function initPageNav() {
  const toggle = document.getElementById("page-nav-toggle");
  const nav = document.getElementById("page-nav");
  const closeBtn = nav?.querySelector(".page-nav__close");

  if (!toggle || !nav || !closeBtn) {
    return;
  }

  const labelOpen =
    toggle.dataset.labelOpen || toggle.getAttribute("aria-label") || "";
  const labelClose = toggle.dataset.labelClose || "";

  function setOpen(open) {
    nav.classList.toggle("page-nav--open", open);
    document.body.classList.toggle("page-nav-is-open", open);
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    nav.setAttribute("aria-hidden", open ? "false" : "true");
    toggle.setAttribute("aria-label", open ? labelClose : labelOpen);
  }

  toggle.addEventListener("click", () => {
    setOpen(!nav.classList.contains("page-nav--open"));
  });

  closeBtn.addEventListener("click", () => {
    setOpen(false);
  });

  document.addEventListener("click", (e) => {
    if (!nav.classList.contains("page-nav--open")) {
      return;
    }
    const t = e.target;
    if (nav.contains(t) || toggle.contains(t)) {
      return;
    }
    setOpen(false);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && nav.classList.contains("page-nav--open")) {
      setOpen(false);
      toggle.focus();
    }
  });
}

function initClickableTableRows() {
  const selector = "tr[data-href]";

  function navigateIfRow(tr) {
    const href = tr.dataset?.href;
    if (!href) {
      return;
    }
    window.location.assign(href);
  }

  document.addEventListener("click", (e) => {
    if (e.target.closest("a, button")) {
      return;
    }
    const tr = e.target.closest(selector);
    if (!tr) {
      return;
    }
    navigateIfRow(tr);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Enter" && e.key !== " ") {
      return;
    }
    const tr = e.target.closest(selector);
    if (!tr) {
      return;
    }
    e.preventDefault();
    navigateIfRow(tr);
  });
}

function initHeroVideo() {
  const video = document.querySelector(".hero__video");
  if (!video) {
    return;
  }
  const hero = video.closest(".hero");
  const markReady = () => {
    hero?.classList.add("hero--video-ready");
  };

  if (video.readyState >= 2) {
    markReady();
  } else {
    video.addEventListener("loadeddata", markReady, { once: true });
  }

  if (video.querySelectorAll("source").length >= 2) {
    const mq = window.matchMedia("(max-width: 767px)");

    function reloadForBreakpoint() {
      hero?.classList.remove("hero--video-ready");
      video.load();
      const onLoaded = () => {
        markReady();
        video.play().catch(() => {});
      };
      video.addEventListener("loadeddata", onLoaded, { once: true });
    }

    mq.addEventListener("change", reloadForBreakpoint);
  }
}

document.addEventListener("DOMContentLoaded", initPageNav);
document.addEventListener("DOMContentLoaded", initClickableTableRows);
document.addEventListener("DOMContentLoaded", initHeroVideo);
